export default __webpack_public_path__ + "static/media/kitchen3-afterB-2048w.b06475e3.png";